import { render, staticRenderFns } from "./sign-export.vue?vue&type=template&id=06ea3890&scoped=true&"
import script from "./sign-export.vue?vue&type=script&lang=js&"
export * from "./sign-export.vue?vue&type=script&lang=js&"
import style0 from "./sign-export.vue?vue&type=style&index=0&id=06ea3890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea3890",
  null
  
)

export default component.exports